import script from "./Reports.vue?vue&type=script&setup=true&lang=js"
export * from "./Reports.vue?vue&type=script&setup=true&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=0b518235&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b518235"]])

export default __exports__